module.exports = __webpack_public_path__ + "img/missionicon.78d80cc.png";